<div class="sso">

    <div class="sso__icon">
      <app-icon iconStyle="reveleer" iconType="reveleer" iconName="logo-vertical"></app-icon>
    </div>
    <div class="sso__form">
        <h2 class="redirect-text">Select User...In Progress</h2>
    </div>
</div>